import type { PropsWithChildren } from "react";
import type { ReportTemplatesContextType } from "./ReportTemplatesContext.ts";
import { ReportTemplatesContext } from "./ReportTemplatesContext.ts";

export const ReportTemplatesContextProvider = ({
  children,
  ...props
}: PropsWithChildren<ReportTemplatesContextType>) => (
  <ReportTemplatesContext value={props}>{children}</ReportTemplatesContext>
);
